// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"82fee6c4","455":"6d0d14a3","977":"0cfee358"}[chunkId] + ".chunk.js";
};